import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Sparkle, CircleNotch, PaperPlaneTilt } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

export default function AddonServices() {
  const { t } = useTranslation();
  const [services, setServices] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => { api.get("/addon-services").then((r) => setServices(r.data || [])).catch(() => {}); }, []);

  const buy = async (s) => {
    setBusy(s.id);
    try {
      const { data } = await api.post(`/addon-services/${s.id}/checkout`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) { toast.error(apiError(e)); setBusy(null); }
  };
  const requestQuote = async (s) => {
    setBusy(s.id);
    try {
      const note = window.prompt(t("addons.quotePrompt", { name: s.name })) || "";
      await api.post(`/addon-services/${s.id}/request`, { note });
      toast.success(t("addons.t_requestSent"));
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(null); }
  };

  if (!services.length) return null;

  return (
    <div className="border border-white/10 rounded-xl p-6 bg-[#121212] mb-8" data-testid="addon-services">
      <div className="flex items-center gap-2 mb-1"><Sparkle size={20} className="text-gold" /><h2 className="font-serif text-2xl">{t("addons.title")}</h2></div>
      <p className="text-sm text-neutral-400 mb-5">{t("addons.subtitle")}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {services.map((s) => (
          <div key={s.id} className="rounded-lg border border-white/10 bg-white/5 p-4 flex flex-col" data-testid={`addon-${s.id}`}>
            <div className="font-medium">{s.name}</div>
            <p className="text-xs text-neutral-400 mt-1 flex-1">{s.description}</p>
            <div className="mt-3 flex items-end justify-between gap-2">
              <div className="text-2xl font-bold text-gold">${s.price}</div>
              <div className="flex gap-2">
                {(s.mode === "quote" || s.mode === "both") && (
                  <Button variant="outline" size="sm" onClick={() => requestQuote(s)} disabled={busy === s.id}
                    className="rounded-full border-white/15 text-neutral-300" data-testid={`addon-request-${s.id}`}>
                    <PaperPlaneTilt size={14} className="mr-1" /> {t("addons.request")}
                  </Button>
                )}
                {(s.mode === "payment" || s.mode === "both") && (
                  <Button size="sm" onClick={() => buy(s)} disabled={busy === s.id}
                    className="rounded-full bg-gold text-obsidian hover:bg-gold/90 font-semibold" data-testid={`addon-buy-${s.id}`}>
                    {busy === s.id ? <CircleNotch className="animate-spin" /> : t("addons.buy")}
                  </Button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
